module.exports = __webpack_public_path__ + "assets/images/typeofcar-01.c46ce2257dcbe920029a827b718a2eb0.svg";